export default {
  form: {
    address: {
      label: 'Dirección',
      placeholder: 'Calle + número',
    },
    city: {
      label: 'Ciudad',
      placeholder: 'Ciudad',
    },
    state: {
      label: 'Estado',
      placeholder: 'Seleccionar estado',
    },
    country: {
      label: 'País',
      placeholder: 'Seleccionar país',
    },
    zip_code: {
      label: 'Código postal',
      placeholder: 'Código postal',
    },
  },
};
